import { RouteRecordRaw } from "vue-router";

export const previewRoute: RouteRecordRaw = {
  path: "",
  name: "PREVIEW_PAGE",
  component: () => import("@/pages/preview/Page.vue"),
  meta: {
    title: "предварительный просмотр",
    activeLinkGroup: "PREVIEW",
    sort: 1,
    sidebar: {
      icon: "watch_later",
      label: "Просмотр",
    },
  },
};
